// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__2jFRJ","left":"InfoRow_left__2lAIM"};